import { render, staticRenderFns } from "./BlueskyModal.vue?vue&type=template&id=5e7f1fe8&scoped=true"
import script from "./BlueskyModal.vue?vue&type=script&lang=js"
export * from "./BlueskyModal.vue?vue&type=script&lang=js"
import style0 from "./BlueskyModal.vue?vue&type=style&index=0&id=5e7f1fe8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f1fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7f1fe8')) {
      api.createRecord('5e7f1fe8', component.options)
    } else {
      api.reload('5e7f1fe8', component.options)
    }
    module.hot.accept("./BlueskyModal.vue?vue&type=template&id=5e7f1fe8&scoped=true", function () {
      api.rerender('5e7f1fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/BlueskyModal.vue"
export default component.exports